import gql from 'graphql-tag'

const getUserInfo = gql`
  query getUserInfo($id: Int!) {
    getUserInfo(id: $id) {
      id
      email
      phone
    }
  }
`

export default getUserInfo
